import {
  Button,
  Col,
  DatePicker,
  Divider,
  InputNumber,
  Row,
  Skeleton,
  Switch,
  Table,
  Tooltip,
  notification,
} from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Select } from "antd";
import type { SelectProps, TableColumnsType } from "antd";
import AdjustBankBalanceModel, {
  AdjustBankType,
} from "../ImportTransactions/AdjustBankBalanceModel";
import LedgerService, {
  SearchLedgerByGroupsTypes,
} from "../../../Services/LedgerService";
import { useClient } from "../../../Context/ClientContext";
import VoucherServices, {
  Party_Tax,
  ReconcileTypes,
  VoucherFilterStatus,
  VoucherMode,
  Voucher_Type,
} from "../../../Services/VoucherServices";
import { dayjs } from "../../../../Utilities/dayjs";
import { useTheme } from "../../../Context/ThemeContext";
import {
  VoucherDetailsData,
  voucherType,
} from "../../Reports/LedgerWiseVoucherDetails/VoucherDetailsByLedger";
import { DeleteTwoTone, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { AddLedger } from "../../Master/Ledger/AddLedger";
import UploadCSVfile from "../ImportTransactions/UploadCSVfile";
import ViewPaymentIn from "../../SalesAndPurchase/ReceiptAndPaymentOut/View/ViewPaymentIn";
import ViewSalesInvoice from "../../SalesAndPurchase/InvoiceAndPurchaseBill/ViewModel/ViewSalesInvoice";
import ViewCreditNote from "../../SalesAndPurchase/CreditAndDebitNote/View/ViewCreditNote";
import ViewJournal from "../../Journals/ViewJournal";
import { Utils } from "../../../../Utilities/Utils";
import { ConfirmationModal } from "../../../Common/ConfirmationModal";
import { notificationContext } from "../../../Common/Routing/PageRoute";
import { useKeyboardShortcuts } from "../../../Common/KeyboardShortcuts ";
import { viewVoucher } from "../../../Services/ViewVoucher";
import PayRecVoucherPDF from "../../SalesAndPurchase/ReceiptAndPaymentOut/Pdf/PayRecVoucherPDF";
import ExpIncVocherPDF from "../../Expenses&income/ExpIncVocherPDF";
import SalesInvoicePDF from "../../SalesAndPurchase/InvoiceAndPurchaseBill/PDF/SalesInvoicePDF";
import PurchaseBillPDF from "../../SalesAndPurchase/InvoiceAndPurchaseBill/PDF/PurchaseBillPDF";
import JournalVoucherPDF from "../../Journals/JournalVoucherPDF";
import { findUserOnlyOnePremission } from "../../Users/Roles/UserSecurityFind";
import { useUser } from "../../../../Context/UserContext";

const BankReconciliation: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const options: SelectProps["options"] = [];
  const { clientSpecificRole } = useUser();
  const { currentClient, companySettings } = useClient();
  const { themeData } = useTheme();
  const { openNotification } = useContext(notificationContext);
  const [open, setIsOpen] = React.useState<boolean>(false);
  const [journalModal, setJournalModal] = React.useState<boolean>(false);
  const [expIncModalOpen, setExpIncModalOpen] = React.useState<boolean>(false);
  const [invoiceModel, setInvoiceModel] = React.useState<string>("");
  const [openModel, setOpenModel] = React.useState<{
    type: string;
    param: any;
  }>({
    type: "",
    param: {},
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [bank, setBank] = React.useState<{
    id: string;
    name: string;
    partyOrTax: Party_Tax;
  }>({
    id: "",
    name: "",
    partyOrTax: Party_Tax.other,
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [ledgerList, setLedgerList] = React?.useState<any>();
  const [ledgerId, setLeadgerId] = React?.useState<string>("");
  const [loading, setLoading] = React?.useState(false);
  const [voucherList, setVoucherList] = React?.useState<any>([]);
  const [pageSize, setPageSize] = React.useState<number>(
    themeData?.tablePageSize ?? 15
  );
  const [page, setPage] = React.useState(1);
  const [searchCustomer, setSearchCustomer] = React.useState<string>("");
  const [showSaveButton, setShowSaveButton] = React.useState<boolean>(false);
  const [saveDisabled, setSaveDisabled] = React.useState<boolean>(true);
  const [openingBalance, setOpeningBalance] = React.useState<number>(0);
  const [displayDate, setDisplayDate] = React.useState<any | undefined>();
  const [lastReconciledDate, setLastReconciledDate] = React.useState<
    any | undefined
  >();
  const [ledDropdownLoading, setLedDropdownLoading] =
    React.useState<boolean>(false);
  const [filterDate, setFilterDate] = React.useState<any>({
    from: companySettings?.period?.from,
    to: dayjs().format("DD/MM/YYYY"),
  });
  const [trigger, setTrigger] = React?.useState(false);
  const [type, setType] = React?.useState<any>();
  const [refresh, setRefresh] = React?.useState(false);
  const [filter, setfilter] = React.useState<any>({
    sortCol: "",
    sortDir: "",
  });
  const [id, setId] = React?.useState<any>();
  const navigate = useNavigate();

  const [selectedOption, setSelectedOption] = React?.useState<number>(2);
  const [inputValue, setInputValue] = React?.useState<number | undefined>(
    undefined
  );
  // const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [paymentId, setPaymentId] = React.useState<string>("");
  // const [open, setOpen] = React.useState<string>("");
  // const [creditModalOpen, setCreditModalOpen] = React.useState<boolean>(false);
  // const [journalModal, setJournalModal] = React.useState<boolean>(false);
  const [deleteVoucher, setDeleteVoucher] = React.useState<{
    id: string;
    isRev: boolean;
    number: string;
  }>({
    id: "",
    isRev: false,
    number: "",
  });
  const [invoiceStatus, setInvoiceStatus] = React.useState<VoucherFilterStatus>(
    VoucherFilterStatus.Active
  );
  // const [confirmation, setConfirmation] = React.useState<boolean>(false);

  const handleSelectChange = (e: any) => {
    setBank({
      id: e.value,
      name: e.lable,
      partyOrTax: e.title,
    });
    setLeadgerId(e.value);
  };

  const handleChange = (val: any) => {
    setSelectedOption(val);
  };

  React?.useEffect(() => {
    getLedgersByGroupName();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger]);

  useEffect(() => {
    GetLastReconcileHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ledgerId]);

  const GetLastReconcileHistory = async () => {
    try {
      console.log("helo");
      if (ledgerId && currentClient?.id) {
        const reconcileHistoryResponse =
          await VoucherServices.GetLastReconcileHistory(
            currentClient?.id,
            ledgerId
          );
        if (reconcileHistoryResponse.status) {
          setDisplayDate(reconcileHistoryResponse?.result?.closingBalDate);
          setLastReconciledDate(
            reconcileHistoryResponse?.result?.closingBalDate
          );
          setOpeningBalance(
            -reconcileHistoryResponse?.result?.closingBalAmount
          );
        } else {
          setOpeningBalance(0);
          setDisplayDate(dayjs());
          setLastReconciledDate(undefined);
        }
      }
    } catch (error) {
      console.log("error", error);
    } finally {
    }
  };

  const getLedgersByGroupName = async () => {
    setLedDropdownLoading(true);
    let res = await LedgerService?.getLedgersByGroupName(
      currentClient?.id,
      SearchLedgerByGroupsTypes?.BankOnly
    );
    if (res) {
      setLedgerList(res);
      setLedDropdownLoading(false);
    } else {
      setLedDropdownLoading(false);
    }
  };

  const changeReconcileStatus = (voucherId: string, isReconciled: boolean) => {
    const updatedVouchers = voucherList.map((voucher: any) => {
      if (voucher.id === voucherId) {
        return {
          ...voucher,
          isReconciled: isReconciled
            ? ReconcileTypes.Reconciled
            : ReconcileTypes.Nonreconciled,
        };
      }
      return voucher;
    });
    setVoucherList(updatedVouchers);
  };

  const postReconcileVoucher = async () => {
    try {
      console.log("voucherList", voucherList);

      setLoading(true);
      console.log(
        "filterDate?.to",
        filterDate?.to,
        new Date(filterDate?.to),
        new Date()
      );

      const reconcileData = {
        ledgerId: ledgerId,
        openingBalDate:
          displayDate > (companySettings?.period?.from || 0)
            ? dayjs(displayDate).add(1, "day").startOf("day").toISOString()
            : dayjs(companySettings?.period?.from).toISOString(),
        closingBalDate: filterDate?.to
          ? dayjs(filterDate?.to, "DD/MM/YYYY").toISOString()
          : new Date().toISOString(),
        openingBalAmount: -openingBalance,
        debitTotalAmount: totalReconciledDebitAmount,
        creditTotalAmount: totalReconciledCreditAmount,
        voucherList: voucherList
          .filter((v: any) => v.isReconciled === ReconcileTypes.Reconciled)
          .map((v: any) => ({
            name: v.number,
            id: v.id,
          })),
      };
      let res = await VoucherServices?.postReconcileVoucher(
        currentClient?.id,
        reconcileData
      );
      if (res?.status) {
        notification.success({
          message: "",
          description: "saved successfully.",
          placement: "topRight",
        });
        setInputValue(0);
        setRefresh((x: boolean) => !x);
        setVoucherList([]);
      } else {
        notification.error({
          message: "",
          description: res?.message || "An error occurred while saving.",
          placement: "topRight",
        });
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  // const permissionEdit = findUserOnlyOnePremission(
  //   "Master.BankReconciliation.Edit",
  //   currentClient?.id!
  // );

  const permissionAdd = findUserOnlyOnePremission(
    "Master.BankReconciliation.Add",
    clientSpecificRole(),
    currentClient?.id!
  );

  const columns: TableColumnsType<VoucherDetailsData> = [
    {
      title: "Date",
      dataIndex: "date",
      ellipsis: true,
      //   width: width <= 1440 ? "10%" : "9%",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
          }}
          title={false}
        >
          {record?.date}
        </Skeleton>
      ),
    },
    {
      title: "Account Name",
      dataIndex: "ledgerName",
      width: "25%",
      align: "left",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.ledgerName}
        </Skeleton>
      ),
    },
    {
      title: "Ref.No",
      dataIndex: "number",
      ellipsis: true,
      //   width: width <= 1440 ? "9%" : "8%",
      align: "left",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          <span
            style={{
              color: themeData?.themeColor,
              cursor: "pointer",
            }}
            onClick={() =>
              viewVoucher(
                record.id,
                record.voucherType,
                setId,
                setIsOpen,
                setPaymentId,
                setType,
                setExpIncModalOpen,
                setInvoiceModel,
                setJournalModal
              )
            }

            // onClick={() => {
            //   if (record?.voucherType === Voucher_Type.Receipt) {
            //     setOpenModel({
            //       type: "viewPayment",
            //       param: "",
            //     });
            //     setPaymentId(record?.id);
            //     setType(record?.voucherType);
            //   } else if (record?.voucherType === Voucher_Type.Payment) {
            //     setOpenModel({
            //       type: "viewPayment",
            //       param: "",
            //     });
            //     setPaymentId(record?.id);
            //     setType(record?.voucherType);
            //   } else if (record?.voucherType === Voucher_Type.SalesVoucher) {
            //     setOpenModel({
            //       type: "viewInvoice",
            //       param: "",
            //     });
            //     setPaymentId(record?.id);
            //     setType(record?.voucherType);
            //   } else if (record?.voucherType === Voucher_Type.PurchaseVoucher) {
            //     setOpenModel({
            //       type: "viewInvoice",
            //       param: "",
            //     });
            //     setPaymentId(record?.id);
            //     setType(record?.voucherType);
            //   } else if (record?.voucherType === Voucher_Type.CreditNote) {
            //     setOpenModel({
            //       type: "returnNote",
            //       param: "",
            //     });
            //     setPaymentId(record?.id);
            //     setType(record?.voucherType);
            //   } else if (record?.voucherType === Voucher_Type.DebitNote) {
            //     setOpenModel({
            //       type: "returnNote",
            //       param: "",
            //     });
            //     setPaymentId(record?.id);
            //     setType(record?.voucherType);
            //   } else if (record?.voucherType === Voucher_Type.Journal) {
            //     setOpenModel({
            //       type: "journal",
            //       param: "",
            //     });
            //     setPaymentId(record?.id);
            //     setType(record?.voucherType);
            //   } else if (record?.voucherType === Voucher_Type.Contra) {
            //     setPaymentId(record?.id);
            //     setOpenModel({
            //       type: "adjustBankBalance",
            //       param: { disable: true },
            //     });
            //   }
            // }}
          >
            {record?.number}
          </span>
        </Skeleton>
      ),
    },
    {
      title: "Voucher",
      dataIndex: "voucherType",
      ellipsis: true,
      //   width: width <= 1440 ? "10%" : "9%",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
          }}
          title={false}
        >
          {voucherType[record?.voucherType]}
        </Skeleton>
      ),
    },
    {
      title: "Debit",
      dataIndex: "amount",
      ellipsis: true,
      //   width: width <= 1440 ? "9%" : "8%",
      align: "right",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "end" },
          }}
          title={false}
        >
          {Utils.getFormattedNumber(record?.amount > 0 ? record?.amount : 0)}
        </Skeleton>
      ),
    },
    {
      title: "Credit",
      dataIndex: "amount",
      ellipsis: true,
      //   width: width <= 1440 ? "9%" : "8%",
      align: "right",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "end" },
          }}
          title={false}
        >
          {Utils.getFormattedNumber(
            Math.abs(record?.amount < 0 ? record?.amount : 0)
          )}
        </Skeleton>
      ),
    },

    {
      title: "Action",
      dataIndex: "id",
      ellipsis: true,
      align: "center",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "end" },
          }}
          title={false}
        >
          <div
            style={{ display: "flex", justifyContent: "space-evenly", gap: 1 }}
          >
            <Tooltip title="Edit" color="#444653" placement="top">
              <EditOutlined
                twoToneColor="#444653"
                onClick={() => {
                  record?.voucherType === Voucher_Type?.Receipt
                    ? navigate(
                        `/billing/clients/${currentClient?.id}/sales/editReceipt/${record?.id}`
                      )
                    : record?.voucherType === Voucher_Type.Payment
                    ? navigate(
                        `/billing/clients/${currentClient?.id}/purchase/editPaymentOut/${record.id}`
                      )
                    : record?.voucherType === Voucher_Type.SalesVoucher
                    ? navigate(
                        `/billing/clients/${currentClient?.id}/sales/editInvoice/${record?.id}`,
                        {
                          state: { copy: false },
                        }
                      )
                    : record?.voucherType === Voucher_Type.PurchaseVoucher
                    ? navigate(
                        `/billing/clients/${currentClient?.id}/sales/editInvoice/${record?.id}`,
                        {
                          state: { copy: false },
                        }
                      )
                    : record?.voucherType === Voucher_Type.CreditNote
                    ? navigate(
                        `/billing/clients/${currentClient?.id}/sales/editCreditNote/${record?.id}`
                      )
                    : record?.voucherType === Voucher_Type.DebitNote
                    ? navigate(
                        `/billing/clients/${currentClient?.id}/sales/editCreditNote/${record?.id}`
                      )
                    : record?.voucherType === Voucher_Type.Journal
                    ? navigate(
                        `/billing/clients/${currentClient?.id}/journals/${record?.id}`
                      )
                    : setId(record?.id);
                  setType(AdjustBankType.BankReconciliation);
                  setOpenModel({
                    type: "adjustBankBalance",
                    param: {
                      id: record?.id,
                      type: "",
                    },
                  });
                  // Navigate
                  // setId(record?.id);
                  // setOpenModel({
                  //   type: "adjustBankBalance",
                  //   param: {
                  //     id: "",
                  //     type: "",
                  //   },
                  // });
                }}
              />
            </Tooltip>
            {/* {invoiceStatus !== VoucherFilterStatus.Deleted && (
              <Tooltip color="red" title="Delete" placement="top">
                <DeleteTwoTone
                  className="ca-delete-btn cursor"
                  twoToneColor="#ff879d"
                  onClick={() => {
                    setOpenModel({
                      type: "delete",
                      param: "",
                    });
                    setPaymentId(record?.id);
                    setDeleteVoucher({
                      ...deleteVoucher,
                      number: record?.number,
                    });
                  }}
                />
              </Tooltip>
            )} */}
          </div>
        </Skeleton>
      ),
    },
  ];

  if (permissionAdd)
    columns.splice(6, 0, {
      title: "Is Reconciled",
      dataIndex: "isReconciled",
      ellipsis: true,
      //   width: width <= 1440 ? "9%" : "8%",
      align: "right",
      render: (checked, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "end" },
          }}
          title={false}
        >
          {
            <>
              <Switch
                // checked={checked === ReconcileTypes.Reconciled}
                size="small"
                defaultChecked={checked === ReconcileTypes.Reconciled}
                onChange={(isChecked) => {
                  changeReconcileStatus(record?.id, isChecked);
                  // console.log("isChecked", isChecked, voucherList);
                }}
              />
            </>
          }
        </Skeleton>
      ),
    });

  React.useEffect(() => {
    if (currentClient?.id) {
      let reconcileType;
      // Use ternary conditional operator to determine reconcileType based on selectedOption
      reconcileType =
        selectedOption === 1
          ? ReconcileTypes.Reconciled
          : selectedOption === 2
          ? ReconcileTypes?.Nonreconciled
          : ReconcileTypes.Both;
      if (ledgerId !== "" && ledgerId !== null) {
        getList(
          currentClient.id,
          Voucher_Type.All,
          dayjs(filterDate.from).toISOString(),
          dayjs(filterDate.to, "DD/MM/YYYY").endOf("day").toISOString(),
          (page - 1) * pageSize,
          pageSize,
          filter.sortCol,
          filter.sortDir,
          ledgerId,
          reconcileType,
          searchCustomer,
          VoucherFilterStatus.Active
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentClient?.id,
    page,
    pageSize,
    filter.sortCol,
    filter.sortDir,
    searchCustomer,
    filterDate.from,
    filterDate.to,
    ledgerId,
    refresh,
    selectedOption, // Include selectedOption in the dependency array
  ]);

  // deleteVoucher api
  React.useEffect(() => {
    if (deleteVoucher?.id) {
      const DeleteCreditNote = async () => {
        setLoading(true);
        await VoucherServices.deleteVoucher(
          currentClient?.id!,
          deleteVoucher.id
        ).then((res) => {
          setLoading(false);
          if (res?.result) {
            setRefresh(!refresh);
            openNotification(
              "success",
              `Voucher ${deleteVoucher.number} deleted successfully.`
            );
          }
        });
      };
      DeleteCreditNote();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteVoucher?.id]);

  const getList = async (
    clientId: string,
    voucherType: Voucher_Type,
    fromDate: string,
    toDate: string,
    start: number,
    length: number,
    sortCol?: string,
    sortDir?: string,
    partyId?: string,
    IsReconcile?: ReconcileTypes,
    search?: string,
    status?: VoucherFilterStatus
  ) => {
    setLoading(true);
    await VoucherServices.getVoucharList(
      clientId,
      voucherType,
      fromDate,
      toDate,
      start,
      length,
      sortCol,
      sortDir,
      partyId,
      IsReconcile,
      search,
      status
    )
      .then((res: any) => {
        console.log("ress", res);
        if (res?.result?.voucherItems?.length > 0) {
          if (ledgerId) {
            setShowSaveButton(true);
          }
          setVoucherList(
            res?.result?.voucherItems
              ?.map((el: any, index: number) => {
                var arr: any = [];
                switch (el.voucherType) {
                  case Voucher_Type.Journal:
                    if (
                      el?.eLedger?.find((item: any) => item.id === ledgerId)
                    ) {
                      var tmpLedList = el?.eLedger?.filter(
                        (itm: any) => itm.id === ledgerId
                      );
                      arr.push({
                        ...tmpLedList[0],
                        amount: tmpLedList[0].amount,
                        ledgerName:
                          el.mode === VoucherMode.Normal
                            ? el?.pLedger[0]?.ledgerName
                            : el.mode === VoucherMode.Opening
                            ? "Opening Balance"
                            : "Closing Balance",

                        voucherType: el?.voucherType,
                        id: el?.vId,
                        ledgerId: el?.pLedger[0]?.id,
                        number: el?.number,
                        mode: el?.mode,
                        isReconciled: el?.isReconciled,
                        voucherStatus: el?.voucherStatus,
                        date: dayjs(el?.date).format("DD/MM/YYYY"),
                      });
                    } else {
                      // eslint-disable-next-line @typescript-eslint/no-redeclare
                      tmpLedList = el?.pLedger?.filter(
                        (itm: any) => itm.id === ledgerId
                      );
                      arr.push({
                        ...tmpLedList[0],
                        amount: tmpLedList[0].amount,
                        ledgerName:
                          el.mode === VoucherMode.Normal
                            ? el?.eLedger[0]?.ledgerName
                            : el.mode === VoucherMode.Opening
                            ? "Opening Balance"
                            : "Closing Balance",
                        ledgerId: el?.eLedger[0]?.id,
                        mode: el?.mode,
                        voucherStatus: el?.voucherStatus,
                        voucherType: el?.voucherType,
                        id: el?.vId,
                        number: el?.number,
                        isReconciled: el?.isReconciled,
                        date: dayjs(el?.date).format("DD/MM/YYYY"),
                      });
                    }
                    break;
                  case Voucher_Type.SalesVoucher:
                  case Voucher_Type.CreditNote:
                    if (el?.pLedger?.find((itm: any) => itm?.id === ledgerId)) {
                      arr.push({
                        ...el?.pLedger[0],
                        // ledgerName:
                        //   el?.eLedger[0]?.ledgerName ??
                        //   el?.dLedger?.filter(
                        //     (x: any) => x?.partyOrTax === Party_Tax.other
                        //   )[0]?.ledgerName,
                        ledgerName: el?.eLedger[0]?.ledgerName,
                        ledgerId: el?.eLedger[0]?.id,
                        amount: el?.pLedger[0].amount, //-itm.amount,
                        voucherType: el?.voucherType,
                        isReconciled: el?.isReconciled,
                        id: el?.vId,
                        number: el?.number,
                        mode: el?.mode,
                        voucherStatus: el?.voucherStatus,
                        date: dayjs(el?.date).format("DD/MM/YYYY"),
                      });
                    } else {
                      if (
                        el?.dLedger?.find((item: any) => item.id === ledgerId)
                      ) {
                        tmpLedList = el?.dLedger?.filter(
                          (itm: any) => itm.id === ledgerId
                        );
                        arr.push({
                          ...tmpLedList[0],
                          amount: tmpLedList[0].amount,
                          ledgerName: el?.pLedger[0]?.ledgerName,
                          // ledgerName:
                          //   el?.pLedger[0]?.ledgerName ??
                          //   el?.dLedger?.filter(
                          //     (x: any) => x?.partyOrTax === Party_Tax.other
                          //   )[0]?.ledgerName,
                          ledgerId: el?.pLedger[0]?.id,
                          voucherType: el?.voucherType,
                          isReconciled: el?.isReconciled,
                          id: el?.vId,
                          number: el?.number,
                          mode: el?.mode,
                          voucherStatus: el?.voucherStatus,
                          date: dayjs(el?.date).format("DD/MM/YYYY"),
                        });
                      }
                      if (
                        el?.eLedger?.find((item: any) => item.id === ledgerId)
                      ) {
                        tmpLedList = el?.eLedger?.filter(
                          (itm: any) => itm.id === ledgerId
                        );
                        arr.push({
                          ...tmpLedList[0],
                          amount: tmpLedList[0].amount,
                          ledgerName: el?.pLedger[0]?.ledgerName,
                          // ledgerName:
                          //   el?.pLedger[0]?.ledgerName ??
                          //   el?.dLedger?.filter(
                          //     (x: any) => x?.partyOrTax === Party_Tax.other
                          //   )[0]?.ledgerName,
                          ledgerId: el?.pLedger[0]?.id,
                          voucherType: el?.voucherType,
                          isReconciled: el?.isReconciled,
                          id: el?.vId,
                          number: el?.number,
                          mode: el?.mode,
                          date: dayjs(el?.date).format("DD/MM/YYYY"),
                          voucherStatus: el?.voucherStatus,
                        });
                      }
                      if (
                        el?.sLedger?.find((item: any) => item.id === ledgerId)
                      ) {
                        tmpLedList = el?.sLedger?.filter(
                          (itm: any) => itm.id === ledgerId
                        );
                        arr.push({
                          ...tmpLedList[0],
                          amount: tmpLedList[0].amount,
                          ledgerName: el?.pLedger[0]?.ledgerName,
                          // ledgerName:
                          //   el?.pLedger[0]?.ledgerName ??
                          //   el?.dLedger?.filter(
                          //     (x: any) => x?.partyOrTax === Party_Tax.other
                          //   )[0]?.ledgerName,
                          ledgerId: el?.pLedger[0]?.id,
                          voucherType: el?.voucherType,
                          isReconciled: el?.isReconciled,
                          id: el?.vId,
                          number: el?.number,
                          mode: el?.mode,
                          date: dayjs(el?.date).format("DD/MM/YYYY"),
                          voucherStatus: el?.voucherStatus,
                        });
                      }
                    }
                    break;
                  case Voucher_Type.PurchaseVoucher:
                  case Voucher_Type.DebitNote:
                  case Voucher_Type.Expenses:
                  case Voucher_Type.Income:
                    if (el?.pLedger?.find((itm: any) => itm?.id === ledgerId)) {
                      var tmpDLedger = el?.dLedger?.filter(
                        (x: any) => x?.partyOrTax === Party_Tax.other
                      );
                      arr.push({
                        ...el?.pLedger[0],
                        ledgerName: el?.eLedger
                          ? el?.eLedger[0]?.ledgerName
                          : tmpDLedger[0]?.ledgerName,
                        ledgerId: el?.eLedger
                          ? el?.eLedger[0]?.id
                          : tmpDLedger[0]?.id,
                        amount: el?.pLedger[0].amount, //-itm.amount,
                        voucherType: el?.voucherType,
                        isReconciled: el?.isReconciled,
                        id: el?.vId,
                        number: el?.number,
                        mode: el?.mode,
                        voucherStatus: el?.voucherStatus,
                        date: dayjs(el?.date).format("DD/MM/YYYY"),
                      });
                    } else {
                      if (
                        el?.dLedger?.find((item: any) => item.id === ledgerId)
                      ) {
                        tmpLedList = el?.dLedger?.filter(
                          (itm: any) => itm.id === ledgerId
                        );
                        arr.push({
                          ...tmpLedList[0],
                          amount: tmpLedList[0].amount,
                          ledgerName: el?.pLedger[0]?.ledgerName,
                          ledgerId: el?.pLedger[0]?.id,
                          voucherType: el?.voucherType,
                          isReconciled: el?.isReconciled,
                          id: el?.vId,
                          number: el?.number,
                          mode: el?.mode,
                          voucherStatus: el?.voucherStatus,
                          date: dayjs(el?.date).format("DD/MM/YYYY"),
                        });
                      }
                      if (
                        el?.eLedger?.find((item: any) => item.id === ledgerId)
                      ) {
                        tmpLedList = el?.eLedger?.filter(
                          (itm: any) => itm.id === ledgerId
                        );
                        arr.push({
                          ...tmpLedList[0],
                          amount: tmpLedList[0].amount,
                          ledgerName: el?.pLedger[0]?.ledgerName,
                          ledgerId: el?.pLedger[0]?.id,
                          voucherType: el?.voucherType,
                          isReconciled: el?.isReconciled,
                          id: el?.vId,
                          number: el?.number,
                          mode: el?.mode,
                          date: dayjs(el?.date).format("DD/MM/YYYY"),
                          voucherStatus: el?.voucherStatus,
                        });
                      }
                      if (
                        el?.sLedger?.find((item: any) => item.id === ledgerId)
                      ) {
                        tmpLedList = el?.sLedger?.filter(
                          (itm: any) => itm.id === ledgerId
                        );
                        arr.push({
                          ...tmpLedList[0],
                          amount: tmpLedList[0].amount,
                          ledgerName: el?.pLedger[0]?.ledgerName,
                          ledgerId: el?.pLedger[0]?.id,
                          voucherType: el?.voucherType,
                          isReconciled: el?.isReconciled,
                          id: el?.vId,
                          number: el?.number,
                          mode: el?.mode,
                          date: dayjs(el?.date).format("DD/MM/YYYY"),
                          voucherStatus: el?.voucherStatus,
                        });
                      }
                    }
                    break;
                  case Voucher_Type.Payment:
                  case Voucher_Type.Receipt:
                    if (el?.eLedger?.find((itm: any) => itm?.id === ledgerId)) {
                      arr.push({
                        ...el?.eLedger[0],
                        ledgerName: el?.pLedger[0]?.ledgerName,
                        ledgerId: el?.pLedger[0]?.id,
                        amount: el?.eLedger[0].amount, //-itm.amount,
                        voucherType: el?.voucherType,
                        isReconciled: el?.isReconciled,
                        id: el?.vId,
                        number: el?.number,
                        mode: el?.mode,
                        date: dayjs(el?.date).format("DD/MM/YYYY"),
                        voucherStatus: el?.voucherStatus,
                      });
                    } else {
                      if (
                        el?.pLedger?.find((item: any) => item.id === ledgerId)
                      ) {
                        tmpLedList = el?.pLedger?.filter(
                          (itm: any) => itm.id === ledgerId
                        );
                        arr.push({
                          ...tmpLedList[0],
                          amount: tmpLedList[0].amount,
                          ledgerName: el?.eLedger[0]?.ledgerName,
                          ledgerId: el?.eLedger[0]?.id,
                          voucherType: el?.voucherType,
                          isReconciled: el?.isReconciled,
                          id: el?.vId,
                          number: el?.number,
                          mode: el?.mode,
                          date: dayjs(el?.date).format("DD/MM/YYYY"),
                          voucherStatus: el?.voucherStatus,
                        });
                      }
                    }
                    break;
                  case Voucher_Type.Contra:
                    if (el?.eLedger?.find((itm: any) => itm?.id === ledgerId)) {
                      arr.push({
                        ...el?.eLedger[0],
                        amount: el?.eLedger[0].amount, //-itm.amount,
                        ledgerName: el?.pLedger[0]?.ledgerName,
                        ledgerId: el?.pLedger[0]?.id,
                        voucherType: el?.voucherType,
                        isReconciled: el?.isReconciled,
                        id: el?.vId,
                        number: el?.number,
                        mode: el?.mode,
                        date: dayjs(el?.date).format("DD/MM/YYYY"),
                        voucherStatus: el?.voucherStatus,
                      });
                    } else {
                      if (
                        el?.pLedger?.find((item: any) => item.id === ledgerId)
                      ) {
                        tmpLedList = el?.pLedger?.filter(
                          (itm: any) => itm.id === ledgerId
                        );
                        arr.push({
                          ...tmpLedList[0],
                          amount: tmpLedList[0].amount,
                          ledgerName: el?.eLedger[0]?.ledgerName,
                          ledgerId: el?.eLedger[0]?.id,
                          voucherType: el?.voucherType,
                          isReconciled: el?.isReconciled,
                          id: el?.vId,
                          number: el?.number,
                          mode: el?.mode,
                          date: dayjs(el?.date).format("DD/MM/YYYY"),
                          voucherStatus: el?.voucherStatus,
                        });
                      }
                    }
                    break;
                }
                return arr;
              })
              .flat()
          );
        } else {
          setShowSaveButton(false);
          setVoucherList([]);
        }
        setLoading(false);

        //   setDueAmount(res?.result.totalDueAmount);
        //setNetAmount(        );
        //setNetAmount(res?.result.totalAmount);
        //   setTotalRecords(res?.totalRecords);
        //   setLoading(false);
        // setVoucherDetailsData(res);
      })
      .catch((ex: any) => {
        setLoading(false);
        setVoucherList([]);
      });
  };

  console.log("Voucher List: ", voucherList);

  const tmpTotal: any = voucherList
    ?.filter((el: any) => el.isReconciled === ReconcileTypes.Reconciled)
    .reduce((acc: number, rcc: any) => acc + rcc?.amount, 0);

  const filterOption = (
    input: string,
    option?: { label: string; value: string }
  ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const totalAfterSubtraction = openingBalance + tmpTotal - (inputValue ?? 0);

  // ----- Short-Cut for Open Model -----F
  useKeyboardShortcuts("N", ["shiftKey"], () => {
    setOpenModel({
      type: "CSVmodal",
      param: {
        id: "",
        type: "",
      },
    });
  });

  const [totalDebitAmount, setTotalDebitAmount] = useState(0);
  const [totalCreditAmount, setTotalCreditAmount] = useState(0);
  const [totalBalance, setTotalBalance] = useState(0);
  const [totalReconciledDebitAmount, setTotalReconciledDebitAmount] =
    useState(0);
  const [totalReconciledCreditAmount, setTotalReconciledCreditAmount] =
    useState(0);
  const [totalReconciledBalance, setTotalReconciledBalance] = useState(0);

  useEffect(() => {
    const calculateTotals = () => {
      const totalDebitAmount = Math.abs(
        voucherList.reduce(
          (acc: any, rcc: any) => acc + (rcc?.amount > 0 ? rcc?.amount : 0),
          0
        )
      );
      const totalCreditAmount = Math.abs(
        voucherList.reduce(
          (acc: any, rcc: any) => acc + (rcc?.amount < 0 ? rcc?.amount : 0),
          0
        )
      );
      const totalBalance = totalDebitAmount - totalCreditAmount;

      const reconciledVouchers = voucherList.filter(
        (el: any) => el.isReconciled === ReconcileTypes.Reconciled
      );

      const totalReconciledDebitAmount = Math.abs(
        reconciledVouchers.reduce(
          (acc: any, rcc: any) => acc + (rcc?.amount > 0 ? rcc?.amount : 0),
          0
        )
      );
      const totalReconciledCreditAmount = Math.abs(
        reconciledVouchers.reduce(
          (acc: any, rcc: any) => acc + (rcc?.amount < 0 ? rcc?.amount : 0),
          0
        )
      );
      const totalReconciledBalance =
        openingBalance +
        totalReconciledDebitAmount -
        totalReconciledCreditAmount;
      setTotalDebitAmount(totalDebitAmount);
      setTotalCreditAmount(totalCreditAmount);
      setTotalBalance(totalBalance);
      setTotalReconciledDebitAmount(totalReconciledDebitAmount);
      setTotalReconciledCreditAmount(totalReconciledCreditAmount);
      setTotalReconciledBalance(totalReconciledBalance);
    };
    calculateTotals();
  }, [voucherList]);

  useEffect(() => {
    if (ledgerId) {
      if (totalReconciledBalance === inputValue && inputValue !== 0) {
        setSaveDisabled(false);
      } else {
        setSaveDisabled(true);
      }
    }
  }, [totalReconciledBalance, inputValue, ledgerId]);

  const permissionCashAdd = findUserOnlyOnePremission(
    "Master.Ledger.Cash.Add",
    clientSpecificRole(),
    currentClient?.id
  );

  const permissionBankAdd = findUserOnlyOnePremission(
    "Master.Ledger.Bank.Add",
    clientSpecificRole(),
    currentClient?.id
  );

  return (
    <>
      <div
        style={{
          // borderRadius: "8px",
          marginTop: 7,
          // backgroundColor: "white",
          padding: "10px 0px 0px 0px",
          // boxShadow: "0px 0px 10px 0px #96A1C84D",
        }}
      ></div>

      <div
        style={{
          marginTop: "8px",
          // padding: "20px 0px 0px 0px",
          backgroundColor: "white",
          // minHeight: window.innerHeight - 200,
          boxShadow: "0px 0px 10px 0px #96A1C84D",
          borderRadius: "8px",
        }}
      >
        <div style={{ padding: "8px 18px 0px 18px" }}>
          {ledgerId && (
            <p style={{ marginBottom: "10px", fontWeight: "bolder" }}>
              {displayDate > (companySettings?.period?.from || 0)
                ? "Last reconciled on " +
                  dayjs(displayDate).format("DD/MM/YYYY")
                : "Reconciliation will start from financial year dating " +
                  dayjs(companySettings?.period?.from).format("DD/MM/YYYY")}
            </p>
          )}
          <Row>
            <Col xs={24} md={16} lg={16}>
              <Row>
                <Col>
                  <Select
                    labelInValue
                    // defaultValue={ledgerList?.value}
                    style={{ width: "150px" }}
                    showSearch
                    loading={ledDropdownLoading}
                    placeholder="Select bank"
                    optionFilterProp="children"
                    options={ledgerList?.map((itm: any) => ({
                      label: itm?.ledgerName.concat(
                        itm?.aliasName ? `${" (" + itm?.aliasName + ")"}` : ""
                      ),
                      value: itm?.id,
                      title: itm?.partyOrTax,
                    }))}
                    onChange={(e) => handleSelectChange(e)}
                    // onSearch={onSearch}
                    filterOption={filterOption}
                    dropdownRender={(customerOptions) => (
                      <>
                        {customerOptions}
                        {(permissionCashAdd || permissionBankAdd) && (
                          <>
                            <Divider style={{ margin: "5px 0px" }} />
                            <Button
                              style={{ width: "100%" }}
                              icon={<PlusOutlined />}
                              type="link"
                              onClick={() => {
                                setOpenModel({
                                  type: "addLedger",
                                  param: {
                                    open: true,
                                  },
                                });
                                // setEditParty({ id: "" });
                              }}
                            >
                              Bank Account
                            </Button>
                          </>
                        )}
                      </>
                    )}
                  />
                </Col>
                <Col>
                  <span style={{ marginLeft: "10px" }}>As on : </span>
                  <DatePicker
                    disabled={!ledgerId}
                    disabledDate={(current) =>
                      ledgerId && lastReconciledDate
                        ? current < dayjs(lastReconciledDate).add(-1, "day")
                        : current <
                          dayjs(companySettings?.period?.from).add(-1, "day")
                    }
                    format="DD/MM/YYYY"
                    allowClear={false}
                    defaultValue={dayjs(filterDate.to, "DD/MM/YYYY")}
                    onChange={(e) => {
                      if (e === null) {
                        setFilterDate({});
                      } else {
                        setFilterDate({
                          ...filterDate,
                          to: dayjs(e),
                        });
                      }
                    }}
                  />
                </Col>

                <span style={{ padding: "8px 5px 4px 8px" }}>
                  Balance as per Bank :
                </span>
                <Col span={3}>
                  <InputNumber
                    disabled={!ledgerId}
                    step={1}
                    min={0}
                    max={999999999}
                    style={{ width: "100%" }}
                    controls={false}
                    placeholder="0.00"
                    value={inputValue}
                    onChange={(e: any) => setInputValue(e)}
                    // formatter={(value: any) =>
                    //   value && Utils.getFormattedNumber(value)
                    // }
                    precision={2}
                  />
                </Col>
                <span style={{ margin: "8px 5px 4px 8px" }}>
                  Difference Amount :
                </span>
                <Col>
                  {totalAfterSubtraction === 0 ? (
                    <>
                      <p style={{ color: "green", paddingTop: "8px" }}>0.00</p>
                    </>
                  ) : (
                    <>
                      <p style={{ color: "red", paddingTop: "8px" }}>
                        {Math.round(totalAfterSubtraction * 100) / 100}
                      </p>
                    </>
                  )}
                </Col>
              </Row>
            </Col>
            <Col xs={24} md={8} lg={8}>
              <Row
                justify={"space-between"}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <span style={{ padding: "8px 5px 4px 0px" }}>Filter by</span>
                <Col style={{ marginRight: "10px" }}>
                  <Select
                    placeholder="Select..."
                    defaultValue={2}
                    value={selectedOption}
                    style={{ width: 160 }}
                    onChange={handleChange}
                    options={[
                      { value: 0, label: "Both" },
                      { value: 1, label: "Reconciled" },
                      { value: 2, label: "Non Reconciled" },
                    ]}
                  />
                </Col>
                <Col style={{ marginRight: "10px" }}>
                  <Button
                    disabled={!ledgerId}
                    type="primary"
                    onClick={() => {
                      setId(undefined);
                      setType(AdjustBankType.BankReconciliation);
                      setOpenModel({
                        type: "adjustBankBalance",
                        param: {
                          id: "",
                          type: "",
                        },
                      });
                    }}
                  >
                    Add Adjustment Entry
                  </Button>
                </Col>
                {/* <Col span={2}>
                  <Button
                    type="primary"
                    onClick={() => {
                      setOpenModel({
                        type: "CSVmodal",
                        param: {
                          id: "",
                          type: "",
                        },
                      });
                    }}
                  >
                    <PlusOutlined />
                  </Button>
                </Col> */}
              </Row>
            </Col>
          </Row>
          <Row justify={"space-between"}>
            <Col span={20}>
              <Row style={{ marginTop: "15px" }}>
                <Col
                  span={5}
                  style={{
                    border: "1px solid #e0e0de",
                    boxShadow: "1px 1px 2px #a0a0ae",
                    padding: "8px",
                    borderRadius: "5px",
                    textAlign: "center",
                  }}
                >
                  <p
                    style={{
                      fontSize: "15px",
                      padding: "5px",
                      marginBottom: "10px",
                    }}
                  >
                    Opening Balance
                  </p>
                  <span style={{ fontSize: "18px" }}>
                    ₹{Utils.getFormattedNumber(openingBalance)}
                  </span>
                </Col>
                <Col
                  span={1}
                  style={{
                    textAlign: "center",
                    paddingTop: "4px",
                    fontSize: "33px",
                  }}
                >
                  -
                </Col>{" "}
                <Col
                  span={5}
                  style={{
                    border: "1px solid #e0e0de",
                    boxShadow: "1px 1px 2px #a0a0ae",
                    padding: "8px",
                    borderRadius: "5px",
                    textAlign: "center",
                  }}
                >
                  <p
                    style={{
                      fontSize: "15px",
                      padding: "5px",
                      marginBottom: "10px",
                    }}
                  >
                    Expenses/Payments
                  </p>
                  <span style={{ fontSize: "18px" }}>
                    ₹
                    {Utils.getFormattedNumber(
                      Math.abs(totalReconciledCreditAmount)
                    )}
                  </span>
                </Col>
                <Col
                  span={1}
                  style={{
                    textAlign: "center",
                    paddingTop: "4px",
                    fontSize: "33px",
                  }}
                >
                  +
                </Col>
                <Col
                  span={5}
                  style={{
                    border: "1px solid #e0e0de",
                    boxShadow: "1px 1px 2px #a0a0ae",
                    padding: "8px",
                    borderRadius: "5px",
                    textAlign: "center",
                  }}
                >
                  <p
                    style={{
                      fontSize: "15px",
                      padding: "5px",
                      marginBottom: "10px",
                    }}
                  >
                    Incomes/Receipts
                  </p>
                  <span style={{ fontSize: "18px" }}>
                    ₹
                    {Utils.getFormattedNumber(
                      Math.abs(totalReconciledDebitAmount)
                    )}
                  </span>
                </Col>{" "}
                <Col
                  span={1}
                  style={{
                    textAlign: "center",
                    paddingTop: "4px",
                    fontSize: "33px",
                  }}
                >
                  =
                </Col>
                <Col
                  span={5}
                  style={{
                    border: "1px solid #e0e0de",
                    boxShadow: "1px 1px 2px #a0a0ae",
                    padding: "8px",
                    borderRadius: "5px",
                    textAlign: "center",
                  }}
                >
                  <p
                    style={{
                      fontSize: "15px",
                      padding: "5px",
                      marginBottom: "10px",
                    }}
                  >
                    Closing Balance
                  </p>
                  <span style={{ fontSize: "18px" }}>
                    ₹{Utils.getFormattedNumber(totalReconciledBalance)}
                  </span>
                </Col>
              </Row>
            </Col>
            <Col style={{ padding: "20px 10px" }}>
              {showSaveButton && (
                <Button
                  type="primary"
                  onClick={() => postReconcileVoucher()}
                  disabled={saveDisabled}
                >
                  Save
                </Button>
              )}
            </Col>
          </Row>
          <div style={{ marginTop: "10px" }}>
            <Table
              className={`Tabel-style table-${
                themeData?.componentSize ?? "middle"
              }`}
              size="small"
              columns={columns}
              dataSource={
                loading
                  ? (Array.from({ length: 15 }, (_, index) => ({
                      key: `loading-${index}`,
                    })) as VoucherDetailsData[])
                  : voucherList
              }
              pagination={false}
              summary={() => {
                return (
                  <Table.Summary fixed>
                    <Table.Summary.Row
                      style={{
                        backgroundColor: "#f5f8ff",
                        fontWeight: "bold",
                        color: "#4d4d4d",
                      }}
                    >
                      <Table.Summary.Cell
                        index={1}
                        className="fw600"
                      ></Table.Summary.Cell>
                      <Table.Summary.Cell
                        index={2}
                        className="fw600"
                      ></Table.Summary.Cell>
                      <Table.Summary.Cell index={3} className="fw600">
                        Total Amount
                      </Table.Summary.Cell>
                      <Table.Summary.Cell
                        index={4}
                        className="fw600"
                      ></Table.Summary.Cell>
                      <Table.Summary.Cell index={5} align="right">
                        ₹ {Utils.getFormattedNumber(totalDebitAmount)}
                      </Table.Summary.Cell>
                      <Table.Summary.Cell
                        index={6}
                        className="fw600"
                        align="right"
                      >
                        ₹ {Utils.getFormattedNumber(totalCreditAmount)}
                      </Table.Summary.Cell>
                      {permissionAdd && (
                        <Table.Summary.Cell index={7} align="right">
                          Balance
                        </Table.Summary.Cell>
                      )}
                      <Table.Summary.Cell index={8} align="right">
                        {!permissionAdd && "Bal"} ₹
                        {Utils.getFormattedNumber(Math.abs(totalBalance))}{" "}
                        {totalBalance > 0
                          ? "Dr."
                          : totalBalance < 0
                          ? "Cr."
                          : null}
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                    {/* <Table.Summary.Row
                      style={{
                        backgroundColor: "#fff9f9",
                        fontWeight: "bold",
                        borderTop: "10px solid black !important",
                      }}
                    >
                      <Table.Summary.Cell
                        index={1}
                        className="fw600"
                      ></Table.Summary.Cell>
                      <Table.Summary.Cell
                        index={2}
                        className="fw600"
                      ></Table.Summary.Cell>
                      <Table.Summary.Cell index={3} className="fw600">
                        Reconciled Amount
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={4} className="fw600">
                        {" "}
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={5} align="right">
                        ₹ {Utils.getFormattedNumber(totalReconciledDebitAmount)}
                      </Table.Summary.Cell>
                      <Table.Summary.Cell
                        index={6}
                        className="fw600"
                        align="right"
                      >
                        ₹{" "}
                        {Utils.getFormattedNumber(totalReconciledCreditAmount)}
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={7} align="right">
                        Balance
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={8} align="right">
                        ₹
                        {Utils.getFormattedNumber(
                          Math.abs(totalReconciledBalance)
                        )}{" "}
                        {totalReconciledBalance > 0
                          ? "Dr."
                          : totalReconciledBalance < 0
                          ? "Cr."
                          : null}
                      </Table.Summary.Cell>
                    </Table.Summary.Row> */}
                  </Table.Summary>
                );
              }}
            />
          </div>
        </div>
      </div>

      {/* {openModel.type === "adjustBankBalance" && (
        <AdjustBankBalanceModel
          open={true}
          onCancel={() => setOpenModel({ type: "", param: "" })}
          // bankAccountTrigger={""}
          // triggerBankTransactions={""}
          type={type}
          bank={bank}
          id={id}
          allBankAccount={ledgerList}
          ledgerName={ledgerId}
          setRefresh={setRefresh}
        />
      )} */}
      {openModel.type === "addLedger" && (
        <AddLedger
          openDrawer={openModel?.param.open}
          id={""}
          setOpenDrawer={() => setOpenModel({ type: "", param: "" })}
          setTrigger={() => setTrigger(!trigger)}
          type={SearchLedgerByGroupsTypes.BankAndCash}
        />
      )}
      {openModel.type === "CSVmodal" && (
        <UploadCSVfile
          open={true}
          onCancel={() => setOpenModel({ type: "", param: "" })}
        />
      )}
      {/* {openModel.type === "viewPayment" && (
        <ViewPaymentIn
          open={true}
          onCancel={() =>
            setOpenModel({
              type: "",
              param: "",
            })
          }
          paymentId={paymentId}
          type={type}
        />
      )}
      {openModel.type === "viewInvoice" && (
        <ViewSalesInvoice
          open={true}
          invVoucharType={type}
          onCancel={() =>
            setOpenModel({
              type: "",
              param: "",
            })
          }
          invoiceId={paymentId}
        />
      )}
      {openModel.type === "returnNote" && (
        <ViewCreditNote
          open={true}
          onCancel={() =>
            setOpenModel({
              type: "",
              param: "",
            })
          }
          creditNoteId={paymentId}
          voucharType={type}
        />
      )}
      {openModel.type === "journal" && (
        <ViewJournal
          open={true}
          onCancel={() =>
            setOpenModel({
              type: "",
              param: "",
            })
          }
          journalId={paymentId}
          type={type}
        />
      )} */}
      {openModel.type === "delete" && (
        <ConfirmationModal
          open={true}
          onNo={() =>
            setOpenModel({
              type: "",
              param: "",
            })
          }
          onYes={() => {
            setDeleteVoucher({
              ...deleteVoucher,
              id: paymentId,
              isRev:
                invoiceStatus === VoucherFilterStatus.Deleted ? true : false,
            });
            setOpenModel({
              type: "",
              param: "",
            });
          }}
          text={
            invoiceStatus === VoucherFilterStatus.Deleted
              ? `Are you sure you want to revive "${deleteVoucher.number}" ?`
              : `Are you sure you want to deleteVoucher "${deleteVoucher.number}" ?`
          }
        />
      )}
      {openModel.type === "adjustBankBalance" && (
        <AdjustBankBalanceModel
          open={true}
          onCancel={() => setOpenModel({ type: "", param: "" })}
          // bankAccountTrigger={() => setBankTrigger(!bankTrigger)}
          // triggerBankTransactions={() =>
          //   setTriggerBankTransactions(!triggerBankTransactions)
          // }
          type={type}
          bank={bank}
          id={id}
          allBankAccount={ledgerList}
          // ledgerName={lederId}
          setRefresh={setRefresh}
          disable={openModel?.param?.disable}
          // item={{ id: bank.id, name: bankAccountDetails?.name }}
        />
      )}
      {open && (
        <PayRecVoucherPDF
          open={open}
          onCancel={() => setIsOpen(false)}
          voucherId={paymentId}
          type={type}
        />
      )}
      {expIncModalOpen && (
        <ExpIncVocherPDF
          open={expIncModalOpen}
          onCancel={() => setExpIncModalOpen(false)}
          voucherId={paymentId}
          type={type}
        />
      )}
      {invoiceModel === "viewSalesInvoice" && (
        <SalesInvoicePDF
          open={invoiceModel === "viewSalesInvoice"}
          invVoucharType={type}
          onCancel={() => setInvoiceModel("")}
          voucherId={paymentId}
        />
      )}
      {invoiceModel === "viewPurchaseBill" && (
        <PurchaseBillPDF
          open={invoiceModel === "viewPurchaseBill"}
          type={type}
          onCancel={() => setInvoiceModel("")}
          voucherId={paymentId}
        />
      )}
      {journalModal && (
        <JournalVoucherPDF
          open={journalModal}
          onCancel={() => setJournalModal(false)}
          voucherId={paymentId}
        />
      )}
    </>
  );
};

export default BankReconciliation;
function async(id: string | undefined) {
  throw new Error("Function not implemented.");
}
